module.exports = __webpack_public_path__ + "media/logos/logo-liga-ventures-5ccd9f7a.png";